import React, { useState } from 'react'
import { useMerchant, readCustomer, readPaymentRequestMerchant, readCardPayout } from "@auth";
import { customersModule } from "@auth/modules";
import { updateSubscription } from "@api/usersController";
import { updateNotificationChannel  } from "@api/merchantsController";
import { Modal, Button } from "@components";
import { toast } from "@components/toast/Toast";
import MailboxForm from "../forms/MailboxForm"
import { useForm } from 'react-hook-form';

const EditSharedMailbox = ({editMailboxDetails, onClose, onComplete, branches}) => {

  const { hasModule, hasPermission } = useMerchant();
  const [loading, setLoading] = useState(false)

  const hasFlag = (data, flag) => {
    return data.subscriptions.filter((x) => x.type === flag && x.active).length > 0;
  }

  const { control, setValue, watch, handleSubmit, formState: { errors, isValid }, reset, clearErrors } = useForm({
    defaultValues: {
      name: editMailboxDetails.name,
      email: editMailboxDetails.emailAddress,
      branchId: editMailboxDetails.branchId ?? "",
      AllPayments: hasFlag(editMailboxDetails, "AllPayments"),
      CustomerPayments: hasFlag(editMailboxDetails, "CustomerPayments"),
      Payouts: hasFlag(editMailboxDetails, "Payouts"),
      TerminalPayments: hasFlag(editMailboxDetails, "TerminalPayments"),
    }
  });

  const userSubId = editMailboxDetails.id

  const allPaymentsIsTrue = watch("AllPayments")
  
  const updateMailbox = async (values) => {
    const { name, email, branchId, ...subValues } = values;

    await updateNotificationChannel (userSubId, { name, email, branchId: branchId ? branchId : null });
    await Promise.all(
      Object.entries(subValues).map(([key, value]) =>
        updateSubscription(userSubId, key, allPaymentsIsTrue && key === "CustomerPayments" ? false : value)
      )
    );
  }

  const onSubmit = async (values) => {
    setLoading(true);
    await updateMailbox(values);
    setLoading(false);

    toast({ description: `Updated "${values.name}" shared mailbox` });
    onComplete();
    handleClose();
  };

  const handleClose = () => {
    reset()
    clearErrors()
    onClose()
  }

  const onSubChange = (name, value) => {
    if (name === "AllPayments" && value) {
      setValue("CustomerPayments", false);
    }
    if (name === "Payouts" && value) {
      setValue("branchId", "");
    }
  }

  const onBranchChange = (value) => {
    if (value !== "") {
      setValue("Payouts", false);
    }
  }

  return (
    <Modal isOpen={!!editMailboxDetails} onClose={handleClose} title="Edit shared mailbox" size="sm">
      <MailboxForm
        control={control}
        handleSubmit={handleSubmit}
        onSubmit ={onSubmit}
        errors ={errors}
        onSubChange={onSubChange}
        hasPermission ={hasPermission}
        hasModule ={hasModule}
        readPaymentRequestMerchant ={readPaymentRequestMerchant}
        customersModule ={customersModule}
        readCustomer ={readCustomer}
        readCardPayout ={readCardPayout}
        allPaymentsIsTrue={allPaymentsIsTrue}
        branches={branches}
        onBranchChange={onBranchChange}
      />
      <div className="p-4 flex gap-2 justify-end">
        <Button onClick={handleClose} disabled={loading} color="secondary">Cancel</Button>
        <Button 
          type="submit" 
          onClick={handleSubmit(onSubmit)} 
          color="primary" 
          disabled={!isValid}
          submitting={loading}
        >Save changes</Button>
      </div>
    </Modal>
  )
}

export default EditSharedMailbox